import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';
import axios from 'axios';

export const exportCsv = (csvContent, name) => {
  const data = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8',
  });
  saveAs(data, `${name}.csv`);
};

export const exportPdf = (pdfContent, filename) => {
  const data = new Blob([pdfContent], {
    type: 'application/pdf;charset=utf-8',
  });
  saveAs(data, filename);
};

export const downloadDocument = (link, filename = null) => {
  if (filename) {
    saveAs(link, filename);
  } else {
    const basename = link.slice(link.lastIndexOf('/') + 1);
    saveAs(link, basename);
  }
};

export const downloadAllDocument = (links) => {
  for (const link of links) {
    downloadDocument(link);
  }
};

export const downloadDocuments = async (documents, filename) => {
  const allPdfDoc = await PDFDocument.create();

  const documentPromises = documents.map(async (document) => {
    try {
      const response = await axios.get(document, { responseType: 'arraybuffer' });
      if (response?.data) {
        const pdfDoc = await PDFDocument.load(response.data);
        const indices = pdfDoc.getPageIndices();
        const pages = await allPdfDoc.copyPages(pdfDoc, indices);

        pages.forEach((page) => {
          allPdfDoc.addPage(page);
        });
      }
    } catch (e) {
      console.error(e);
    }
  });

  await Promise.all(documentPromises);
  const pdfData = await allPdfDoc.save();
  exportPdf(pdfData, filename);
};
